import React from 'react';
import { useEffect, useState } from 'react';
import { Chart as ChartJS,  ArcElement, Tooltip, Legend  } from 'chart.js';
import { Doughnut  } from 'react-chartjs-2';
import Axios from '../../../../services/AxiosInstance';

ChartJS.register(
    ArcElement,
     Tooltip,
     Legend 
);


export default function RechargePlanStatusReport() {
  const [chart, setChart] = useState([])




  
  useEffect(() => {
    const fetchCoins  = async () => {
      Axios.get("api/admin/reports/recharge-plan-history-report")
      .then((res)=>{
        // alert("hii");
        
        setChart(res.data)
      }).catch((e)=>{
        console.log(e);
      })
       
    };
    fetchCoins();
}, [])
// console.log('hii',chart)
 
  var data = {
    // labels: ['Red', 'Blue','Yellow','Green', 'purple', 'orange'],
    labels: chart?.data?.map(x => x.label),
    datasets: [{
      label: `${chart?.length} Total Recharge Plan Data `,
      data: chart?.data?.map(x => x.no_of_plan),
      // label: `# of votes`,
      // data: [12, 19, 3, 5, 2, 3],
      backgroundColor: [
        'rgba(54, 162, 235, 0.2)',
        'rgba(255, 99, 132, 0.2)',
       
            
      ],
      borderColor: [
        'rgba(54, 162, 235, 0.2)',
        'rgba(255, 99, 132, 1)',
      ],
      borderWidth: 1
    }]
  };

  var options = {
    maintainAspectRatio: false,
    scales: {
    },
    legend: {
      labels: {
        fontSize: 15,
      },
    },
  }

  return (
    <div className=''
    
    
    >
      <Doughnut
        data={data}
        height={400}
        options={options}

      />
    </div>
  )
}
